export const dispatchWindowEvent = (name, detail) => {
  try {
    window.dispatchEvent(new CustomEvent(name, { detail }));
  } catch (err) {
    console.log(`Error dispatching ${name} event:`, err);
  }
};
